// extracted by mini-css-extract-plugin
export default {"title":"Cards_title__nT4UL","verticalContainer":"Cards_verticalContainer__XXxl0"};